<template>
    <div class="destination-item">
        <div class="destination__image">
            <img src="assets/images/destination1.png" class="Hong Kong, China image" />

            <div class="destination__overlay" v-if="hasOverlay">
                <button>
                    <i class="plus-icon"></i> Add Itinerary
                </button>
            </div>
        </div>
        <div class="destination__title">Hong Kong, China</div>
        <p class="destination__desc">We curate trips that match your interest.</p>
    </div>
</template>

<script>
    export default {
        name: 'DestinationItem',
        props: ['hasOverlay']
    }
</script>

<style scoped lang="scss">
    .destination-item {
        margin: 27px 18px;
        text-align: center;

        @media all and (max-width: $breakpoint) {
            margin: 0;
        }
    }

    .destination-item:not(:first-child) {

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .destination__image {
        position: relative;
        width: 247px;

        @media all and (max-width: $breakpoint) {
            width: 100%;
        }
    }

    .destination__image::before {
        content: "";
        display: block;
        padding-top: calc(100% / 247 * 331);
    }


    .destination-item img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }


    .destination__title {
        font-weight: $heavy;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 24px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            font-size: 14px;
        }
    }


    .destination__desc {
        margin-top: 6px;
        font-size: 12px;

        @media all and (max-width: $breakpoint) {
            margin-top: 4px;
        }
    }


    .destination__overlay {
        background-color: rgba(0, 0, 0, 0.56);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }


    .destination__overlay button {
        font-family: 'Montserrat', sans-serif;
        font-weight: $semibold;
        font-size: 16px;
        color: white;
    }


    .destination__overlay .plus-icon {
        display: block;
        margin: 0 auto 21px;
        width: 51px;
        height: 51px;
    }
</style>
